'use client';
import { HTMLAttributes, PropsWithChildren, useState } from 'react';
import dynamic from 'next/dynamic';
import { clsx } from 'clsx';
import { ContactUs } from '@/components/features/ContactUs/ContactUs';
import { useAboutDataContext } from '@/providers/AboutDataProvider';
import s from './OrderCallWrapper.module.scss';

const Modal = dynamic(() => import('@/components/layouts/Modal/Modal'), { ssr: false });

interface Props extends PropsWithChildren, HTMLAttributes<HTMLDivElement> {
}

export const OrderCallWrapper = ({ children, className }: Props) => {
  const [isOpen, setIsOpen] = useState(false);
  const { aboutData } = useAboutDataContext();

  return (
    <>
      <div className={clsx(s.wrapper, className)} onClick={() => setIsOpen(true)}>
        {children}
      </div>
      <Modal isOpen={isOpen} onClose={() => setIsOpen(false)} maxWidth={'616px'}>
        <ContactUs aboutData={aboutData} closeModal={() => setIsOpen(false)} />
      </Modal>
    </>
  );
};